import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  DEROM_DASHBOARD_PATH,
  DEROM_PATH,
  DEROM_TEST_RESULTS_PATH,
  DEROM_VACCINATION_RECORDS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const DeromDashBoardPage = lazy(
  () => import('@features/HealthRecords/DEROM/pages/DeromDashBoardPage/DeromDashBoardPage')
);
const DeromPage = lazy(() => import('@features/HealthRecords/DEROM/pages/DeromPage/DeromPage'));
const DeromTestResultPage = lazy(
  () => import('@features/HealthRecords/DEROM/pages/DeromTestResultPage/DeromTestResultPage')
);
const VaccinationRecords = lazy(
  () => import('@features/HealthRecords/DEROM/pages/VaccinationRecords/VaccinationRecords')
);

export const DEROM_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <DeromPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: DEROM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.derom,
    titleTransKey: 'title',
    translationFile: 'derom',
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <DeromDashBoardPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: DEROM_DASHBOARD_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.derom,
    titleTransKey: 'title',
    translationFile: 'derom',
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <DeromTestResultPage />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: DEROM_TEST_RESULTS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.derom,
    titleTransKey: 'title',
    translationFile: 'derom',
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <VaccinationRecords />,
    displayTitle: () => '',
    pageType: PageType.PRIVATE,
    path: DEROM_VACCINATION_RECORDS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.derom,
    titleTransKey: 'titleCompletedVaccinations',
    translationFile: 'derom',
  },
];
